<template>
  <div>
    <NavigationBar
      titel="Einladung bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-form
              @submit.prevent="updateItem"
              v-model="formIsValid"
              class="col s8"
            >
              <v-col cols="12">
                <Subheader
                  icon="mdi-account-clock"
                  title="Allgemein"
                ></Subheader>
                <div class="mt-7">
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                              v-model="data.email"
                              label="E-Mail-Adresse"
                              required
                              :rules="[rules.email, rules.required]"
                              outlined
                              prepend-inner-icon="mdi-email-outline"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-autocomplete
                              v-model="data.group"
                              :items="userGroupsFiltered"
                              item-text="title"
                              item-value="id"
                              return-object
                              hint="Grundlegende Berechtigungen"
                              required
                              :rules="[rules.required]"
                              persistent-hint
                              outlined
                              chips
                              small-chips
                              prepend-inner-icon="mdi-shield-account-outline"
                              label="Benutzergruppe"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-autocomplete
                              v-model="data.division"
                              :items="divisionsFiltered"
                              item-text="title"
                              item-value="id"
                              return-object
                              hint="Organisatorische Zuordnung"
                              required
                              :rules="[rules.required]"
                              persistent-hint
                              outlined
                              chips
                              small-chips
                              prepend-inner-icon="mdi-office-building-outline"
                              label="Abteilung"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-select
                              v-model="data.license"
                              :items="products"
                              item-text="title"
                              item-value="id"
                              item-key="id"
                              return-object
                              :hint="
                                data.license && data.license.price
                                  ? formatPrice(data.license.price)
                                  : 'Bitte wählen Sie eine Lizenz aus'
                              "
                              required
                              :rules="[rules.required]"
                              persistent-hint
                              outlined
                              chips
                              small-chips
                              prepend-inner-icon="mdi-key-variant"
                              label="Lizenz"
                            >
                              <template v-slot:item="{ item }">
                                <div>
                                  <div>{{ item.title }}</div>
                                  <div
                                    class="text-caption text--secondary"
                                    v-if="item.price"
                                  >
                                    {{ formatPrice(item.price) }}
                                  </div>
                                </div>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-form>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { ADMIN, MEMBER_MANAGEMENT } from "@/store/modules.js";
import {
  GET_USER_GROUPS,
  GET_DIVISIONS,
  UPDATE_INVITE,
} from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";

export default {
  name: "admin-users-tab-accounts-invite-edit",
  components: {
    NavigationBar,
    Subheader,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],

      rules: {
        required: (value) => !!value || "Erforderlich.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Ungültige E-Mail-Adresse.";
        },
      },
      formIsValid: false,
      data: null,
      products: [],
    };
  },
  computed: {
    benutzergruppen() {
      return this.$store.state.admin.userGroups;
    },
    divisions() {
      return this.$store.state.memberManagement.divisions;
    },
    userGroupsFiltered() {
      const input = this.$store.state.admin.userGroups;

      const filtered = input.map((item) => {
        const container = {};
        container.title = item.title;
        container.id = item.meta.id;
        return container;
      });

      return filtered;
    },
    divisionsFiltered() {
      const input = this.$store.state.memberManagement.divisions;

      const filtered = input.map((item) => {
        const container = {};
        container.title = item.title;
        container.id = item.meta.id;
        return container;
      });

      return filtered;
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ADMIN}${GET_USER_GROUPS}`, {
        organizationId: this.$route.params.organizationId,
      });
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_DIVISIONS}`, {
        organizationId: this.$route.params.organizationId,
      });
      this.getProducts();

      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("invites")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.data = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    getProducts() {
      db.collection("products")
        .where("active", "==", true)
        .where("userVisible", "==", true)
        .where("userSelectable", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();

            let priceInfo = null;
            if (data.prices && Array.isArray(data.prices)) {
              const recurringPrice = data.prices.find(
                (p) =>
                  p.active &&
                  p.visibleToUsers === true &&
                  p.recurring &&
                  p.recurring.interval === "month"
              );
              if (recurringPrice) {
                priceInfo = {
                  amount: recurringPrice.unitAmount,
                  currency: recurringPrice.currency,
                  interval: recurringPrice.recurring.interval,
                };
              }
            }

            this.products.push({
              title: data.name,
              id: doc.id,
              isDefault: data.isDefault || false,
              price: priceInfo,
            });
          });
        });
    },
    formatPrice(priceInfo) {
      if (
        !priceInfo ||
        priceInfo.amount === null ||
        priceInfo.amount === undefined
      )
        return "";
      const amount = (priceInfo.amount / 100).toFixed(2).replace(".", ",");
      const currency =
        priceInfo.currency === "eur" ? "€" : priceInfo.currency.toUpperCase();

      const intervalMap = {
        day: "Tag",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
      };
      const interval = intervalMap[priceInfo.interval] || priceInfo.interval;

      return `${currency}${amount} / ${interval}`;
    },
    updateItem() {
      if (this.formIsValid) {
        this.$store.dispatch(`${ADMIN}${UPDATE_INVITE}`, {
          organizationId: this.$route.params.organizationId,
          itemId: this.$route.params.itemId,
          email: this.data.email,
          group: this.data.group,
          division: this.data.division,
          license: this.data.license,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>

<style></style>
